import type {
  MaritimeBroadcastWidgetConfiguration,
  MaritimeForecastWidgetConfiguration,
  MaritimeSeichesWidgetConfiguration,
} from "./generated";

export type {
  MaritimeBroadcastWidgetConfiguration,
  MaritimeForecastWidgetConfiguration,
  MaritimeSeichesWidgetConfiguration,
};

export const MARITIME_BROADCAST_TYPES = [
  "marifoon_nl",
  "marifoon_en",
  "shipping_forecast_nl",
  "navtex",
] as const;

export type MaritimeBroadcastType = (typeof MARITIME_BROADCAST_TYPES)[number];

export type MaritimeWidgetConfiguration =
  | MaritimeBroadcastWidgetConfiguration
  | MaritimeForecastWidgetConfiguration
  | MaritimeSeichesWidgetConfiguration;

export function isMaritimeBroadcastType(value: string): value is MaritimeBroadcastType {
  return (MARITIME_BROADCAST_TYPES as readonly string[]).includes(value);
}

export function isMaritimeBroadcastConfiguration(
  config: unknown,
): config is MaritimeBroadcastWidgetConfiguration {
  if (!config || typeof config !== "object") return false;
  const c = config as Record<string, unknown>;
  return (
    c.type === "maritime_broadcast" &&
    typeof c.broadcast_type === "string" &&
    isMaritimeBroadcastType(c.broadcast_type)
  );
}

export function isMaritimeForecastConfiguration(
  config: unknown,
): config is MaritimeForecastWidgetConfiguration {
  if (!config || typeof config !== "object") return false;
  const c = config as Record<string, unknown>;
  if (c.type !== "maritime_forecast") return false;
  if (!Array.isArray(c.area_ids)) return false;
  return c.area_ids.every((id) => typeof id === "string" && id.length > 0);
}

export function isMaritimeSeichesConfiguration(
  config: unknown,
): config is MaritimeSeichesWidgetConfiguration {
  if (!config || typeof config !== "object") return false;
  const c = config as Record<string, unknown>;
  return (
    c.type === "maritime_seiches" && typeof c.area_id === "string" && c.area_id.length > 0
  );
}
